import type { RichTextContentProtocol, SmsCodeProtocol } from '@lighthouse/core'
import type { FetchPexelsParams, PexelsResponse } from '@lighthouse/shared'

import type { HttpResp } from '@/http'
import http from '@/http'

import { JsonContentType } from './constant'
import type { GetAppOfOutsideRes, GetAppOfOutsideResult } from './types'
/**
 * 发送验证码
 * @param {SmsCodeProtocol} payload
 * @returns
 */
export async function sendAuthCode(payload: SmsCodeProtocol): Promise<boolean> {
    const res = await http.post<unknown, HttpResp<boolean>>('api/auth/v1/sms/getSmsCode', payload, { headers: JsonContentType })
    return res.success
}

type VersionNotification = { title?: string; description?: RichTextContentProtocol; files?: string[] }
interface VersionNotificationRes {
    notificationId: string
    items: VersionNotification[]
}
/**
 * 获取版本更新通知
 * @returns
 */
export async function getVersionNotification(): Promise<VersionNotificationRes> {
    const res = await http.get<unknown, HttpResp<VersionNotificationRes>>('api/v1/operation/getLatestUpdates')
    return res.content
}

// 获取应用数据（外部）

export async function getAppOfOutside(appId: string): Promise<GetAppOfOutsideResult> {
    const resp = await http.get<unknown, HttpResp<GetAppOfOutsideRes>>('api/auth/v1/getApp', {
        params: {
            appId
        }
    })

    const { version, config, ...rest } = resp.content
    const { config: versionConfig, ...resetVersion } = version

    return {
        ...rest,
        config: { ...config, ...versionConfig },
        version: resetVersion
    }
}

// 是否登录（外部）

export async function hasLoggedIn(): Promise<boolean> {
    try {
        const res = await http.get<unknown, HttpResp<boolean>>('api/auth/v1/hasLoggedIn')
        return res.content
    } catch {
        return false
    }
}

export async function getPexelsList(params: FetchPexelsParams): Promise<PexelsResponse> {
    const { search, currentPage } = params
    const res = await http.get<unknown, HttpResp<PexelsResponse>>('api/v1/third/pexels/search', {
        params: {
            keyword: search,
            currentPage
        }
    })
    return res.content
}
